import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  uploadDialog: {
    maxHeight: 285,
    width: 460,
  },
  syncSuccesModal: {
    height: 424,
    width: 516,
  },
  successColor: {
    backgroundColor: 'rgb(0, 213, 146)',
  },
  errorColor: {
    backgroundColor: theme.palette.error.main,
  },
  progressBar: {
    height: 15,
    backgroundColor: 'transparent',
    borderRadius: 5,
  },
  showDetails: {
    transform: 'rotate(180deg)',
  },
  uploadWrapper: {
    maxHeight: 300,
    overflow: 'auto',
  },
  syncButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
  successText: {
    color: 'rgb(0, 213, 146)',
  },
}));
